"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullNewOrderDate = void 0;
const fullNewOrderDate = (date) => {
    const formatDate = date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return formatDate.replace('г.', '\u{25CF}');
};
exports.fullNewOrderDate = fullNewOrderDate;
